import { render, staticRenderFns } from "./edit-tag-filter-dialog.vue?vue&type=template&id=5b7c7fb8&scoped=true&"
import script from "./edit-tag-filter-dialog.vue?vue&type=script&lang=js&"
export * from "./edit-tag-filter-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7c7fb8",
  null
  
)

export default component.exports